import { render, staticRenderFns } from "./baseDataAdd.vue?vue&type=template&id=0fb221f2&scoped=true"
import script from "./baseDataAdd.vue?vue&type=script&lang=js"
export * from "./baseDataAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fb221f2",
  null
  
)

export default component.exports